import * as React from 'react';
import { type PropsWithChildren, createContext, useContext } from 'react';

const UnifiedEnrolledProductsExperimentContext = createContext<boolean | undefined>(undefined);

export const useAgnosticEnrolledProductsExperiment = (): boolean => {
  const value = useContext(UnifiedEnrolledProductsExperimentContext);
  return value ?? false;
};

type UnifiedEnrolledProductsExperimentProviderProps = PropsWithChildren<{
  programAgnosticEnrolledProducts: boolean;
}>;

export const UnifiedEnrolledProductsExperimentProvider = ({
  programAgnosticEnrolledProducts,
  children,
}: UnifiedEnrolledProductsExperimentProviderProps) => {
  return (
    <UnifiedEnrolledProductsExperimentContext.Provider value={programAgnosticEnrolledProducts}>
      {children}
    </UnifiedEnrolledProductsExperimentContext.Provider>
  );
};

export default UnifiedEnrolledProductsExperimentProvider;
